"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatorBuilder = void 0;
const Validator_1 = require("./Validator");
exports.validatorBuilder = () => {
    const ruleSets = [];
    let currentRule = undefined;
    const withField = (fieldName) => {
        currentRule.fields[fieldName] = [];
        return fieldConfig(currentRule.fields[fieldName]);
    };
    const withFieldValueConstraint = (path, value, errorMessage) => {
        currentRule.constraints = currentRule.constraints || [];
        currentRule.constraints.push({
            type: 'FIELD_VALUE',
            path,
            value,
            errorMessage,
        });
        return ruleConfig;
    };
    const withConstraint = (constraintConfig) => {
        currentRule.constraints = currentRule.constraints || [];
        currentRule.constraints.push(constraintConfig);
        return ruleConfig;
    };
    const fieldConfig = (rules) => {
        const ruleConfigurator = {
            withConstraint,
            withFieldValueConstraint,
            withField,
            newRule,
            validate(ruleConfig) {
                rules.push(ruleConfig);
                return ruleConfigurator;
            },
            build: () => {
                return new Validator_1.Validator({ ruleSets });
            },
        };
        return ruleConfigurator;
    };
    const ruleConfig = {
        withConstraint,
        withFieldValueConstraint,
        withField,
    };
    const newRule = () => {
        currentRule = { fields: {} };
        ruleSets.push(currentRule);
        return ruleConfig;
    };
    return {
        newRule,
    };
};
//# sourceMappingURL=ValidatorBuilder.js.map